
import Vue from 'vue'
import axios from '@/common/utils/axios_utils'
import { ENDPOINT } from '@/product/const'
import { SYSTEM_ERROR } from '@/common/constants'
export default Vue.extend({
  data(): {
    isSubmitProcessing: boolean
  } {
    return {
      isSubmitProcessing: false
    }
  },
  computed: {
    estimate() {
      return this.$store.getters.estimate
    },
    product() {
      return this.$store.getters.product
    },
    disableLink(): boolean {
      return !this.$store.getters.isSendable || this.isSubmitProcessing || this.isPlainGoodLimit === undefined
    },
    isPlainGoodLimit(): boolean {
      return this.product.plain_good && this.product.plain_good_limit
    },
    selectedOption(): string {
      const checkOptionSelectionLength = `(${this.estimate.first_selected_option.sku_selection_name}${this.product.second_options.length ? `, ${this.estimate.second_selected_option.sku_selection_name}` : ''})`
      return this.product.first_options.length ? checkOptionSelectionLength : ''
    }
  },
  methods: {
    handleAddToCart() {
      this.isSubmitProcessing = true
      const params = {
        printable_sku_id: this.$store.state.estimate.printable_sku_id,
        quantity:this.$store.state.estimate.quantity,
        trial: false
      }
      axios.post(ENDPOINT.CART_ITEMS, params).then(() => {
        this.isSubmitProcessing = false
        location.href = '/cart'
      }).catch(err => {
        this.isSubmitProcessing = false
        alert(err || SYSTEM_ERROR.UNKNOWN)
      })
    }
  }
})
